<template>
  <span
    class="agreement-status-badge"
    :style="badgeStyle">
    {{ name }}
  </span>
</template>

<script>
const AGREEMENT_STATUS_COLORS = {
  Activo: { background: '#E1F5EE', color: '#085041' },
  Incumplimiento: { background: '#FAEEDA', color: '#633806' },
  Cancelado: { background: '#FCEBEB', color: '#791F1F' },
  Pagado: { background: '#E6F1FB', color: '#0C447C' },
};

const DUE_STATUS_COLORS = {
  Vigente: { background: '#F1EFE8', color: '#444441' },
  Mora: { background: '#FAEEDA', color: '#633806' },
  Pagada: { background: '#E1F5EE', color: '#085041' },
  Cancelado: { background: '#FCEBEB', color: '#791F1F' },
};

export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'agreement',
      validator: value => ['agreement', 'due'].includes(value),
    },
  },
  computed: {
    badgeStyle() {
      const palette = this.type === 'due' ? DUE_STATUS_COLORS : AGREEMENT_STATUS_COLORS;
      const colors = palette[this.name] || { background: '#F1EFE8', color: '#444441' };

      return {
        backgroundColor: colors.background,
        color: colors.color,
      };
    },
  },
};
</script>

<style scoped>
.agreement-status-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/agreements/AgreementStatusBadge.vue